import React, { useState, useEffect, useRef } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import EditorHome from './EditCenterPanels/EditorHome';
import EditDocument from './EditCenterPanels/EditDocument';
import News from '../News';

const EditCenter = () => {
    const LoginStates = useSelector(state => state.login);
    const history = useNavigate();
    const [docBoxList, setDocBoxList] = useState([]);    
    const location = useLocation();
    const [currentDocBox, setCurrentDocBox] = useState(null);

    useEffect(() => {     
        if (LoginStates.userId === '') { 
            return;
        } else if (LoginStates.userId !== "" && !LoginStates.userRole.includes('Editor')) {
            history("/")
        }
        fetch (`api/Edit/${LoginStates.userId}`,{
            method: 'GET'
        }).then((response) => response.json())
        .then(data => {            
            setDocBoxList(data);
        });        
    }, [LoginStates]);
    const goEditorHome = () => {
        setCurrentDocBox(null);
        history('/EditCenter');
    };
    return (
            <div className="manual-editor">               
                <header className="gnb">
                    <button className='btn-editorhome' onClick={ (e) => goEditorHome()}></button>
                    <ul className='editor-menu'>
                        <li><Link to='/EditCenter/News'>공지사항</Link></li>
                    </ul>
                </header>
                {
                    location.pathname === '/EditCenter/News' 
                    ? <News />
                    : currentDocBox == null
                        ? <EditorHome docBoxList={docBoxList} setDocBoxList={setDocBoxList} setCurrentDocBox={setCurrentDocBox}/>
                        : <EditDocument setDocBoxList={setDocBoxList} currentDocBox={currentDocBox} setCurrentDocBox={setCurrentDocBox} />
                }
                
            </div>
    );
};

export default EditCenter;
